import { forEach, find } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export const addSelectedVariantToLineItem = (lineItem, variant, orderItemVariantIn) => {
  lineItem.selectedVariants.push({
    order_item_variant_id: orderItemVariantIn.id,
    variant_id: variant.id,
    variant_name: variant.name,
    variant_option_id: orderItemVariantIn.variant_option_id,
    variant_option_name: orderItemVariantIn.variant_option_name,
    _destroy: false
  });
};

export const buildProductVariantOptions = (lineItem) => {
  const variants = [];

  forEach(lineItem.product_variants, (variant) => {
    const builtVariant = {
      order_item_variant_id: null,
      id: variant.id,
      name: variant.name,
      selected_variant_option_id: null,
      options: [
        {
          value: null,
          label: 'Ninguno',
          variant_id: variant.id,
          variant_name: variant.name
        }
      ]
    };

    const orderItemVariant = find(
      lineItem.order_item_variants,
      (o) => o.variant_id === variant.id
    );

    if (orderItemVariant) {
      builtVariant.order_item_variant_id = orderItemVariant.id;
      builtVariant.selected_variant_option_id = orderItemVariant.variant_option_id;
      addSelectedVariantToLineItem(lineItem, variant, builtVariant);
    }

    forEach(variant.product_variant_options, (opt) => {
      builtVariant.options.push({
        value: opt.id,
        label: opt.name,
        variant_id: variant.id,
        variant_name: variant.name
      });
    });

    variants.push(builtVariant);
  });

  return variants;
};

export const buildLineItems = (order) => {
  if (!order?.order_items) return [];

  return order.order_items.map((item) => ({
    ...item,
    selected: false,
    editableCustomTax: false,
    lineIdentifier: uuidv4(),
    productOptions: [],
    selectedVariants: [],
    variants: buildProductVariantOptions(item)
  }));
};

export const normalizeTerms = (order) => {
  const { customer } = order;
  if (customer.id) {
    customer.id_in_shops = customer.id;
    customer.web_id_in_shop = customer.web_id;
  }

  if (
    order?.terms_and_conditions?.length
    && !order?.terms_and_condition?.terms_conditions_content?.length
  ) {
    return {
      ...order,
      terms_and_condition: {
        terms_conditions_content: order.terms_and_conditions
      },
      customer
    };
  }

  return order;
};
